<template>
  <div class="flex gap-4 items-start capitalize text-sm">
    <dt
      class="flex gap-2 items-center font-semibold w-1/3"
      :class="{ 'lg:w-1/4': !isPath }"
    >
      <SvgIcon
        aria-hidden="true"
        :icon-name="icon"
        class="shrink-0"
        width="16"
        height="16"
      />
      <span v-text="label" />
    </dt>
    <dd
      class="w-2/3 flex flex-wrap gap-1"
      :class="{ 'lg:w-3/4': !isPath }"
    >
      <slot />
    </dd>
  </div>
</template>

<script lang="ts">
export default { name: 'DetailRow' }
</script>

<script setup lang="ts">
import { computed } from 'vue'

import { RecordType } from '~/types/records/RecordType'

const props = withDefaults(defineProps<{
  icon: string,
  label: string,
  recordType?: RecordType,
}>(), {
  recordType: RecordType.Lesson,
})

const isPath = computed(() => props.recordType === RecordType.Path)

</script>
